import axiosInstance from "../AxiosInstance";

export function login(email, password) {
    const postData = {
        email,
        password
    };
    return axiosInstance.post(
        'login',
        postData,
    );
}

export function forgotPassword(email) {
  return axiosInstance.post('forgot-password', email);
}

export function markTourCompleted(tourId) {
  return axiosInstance.post(`me/completed-tours/${encodeURIComponent(tourId)}`);
}

export function clearTourCompletion(tourId) {
  return axiosInstance.delete(`me/completed-tours/${encodeURIComponent(tourId)}`);
}
